import React from 'react';
import { SortOption } from 'client/generated';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';
import { Option } from 'client/components/recruitments/Modal/SortSettingModal/Option';
import { Modal } from 'client/components/common/Modal';
import { useRouter } from 'next/router';
import { useUrlQueryParams } from 'client/hooks/recruitment/RecruitmentList/useUrlQueryParams';

type Props = {
  sortOptions: SortOption[];
};

export const SortSettingModal: React.FC<Props> = ({ sortOptions }) => {
  const router = useRouter();
  const {
    searchQueryParams: {
      date: selectedDateText,
      areaIds,
      licenseIds,
      facilityFeatureIds,
      jobBenefitIds,
      sortOptionId,
      maximumDailyWage,
      minimumDailyWage,
      workingHourOptionIds,
      maximumWorkingHours,
      jobTaskIds,
      onlyRecruiting,
    },
    dispatch,
  } = useRecruitmentListContext();

  const closeModal = () => {
    dispatch({
      type: 'changeDisplayMode',
      payload: { displayMode: 'list' },
    });
  };

  const clearSortOption = () => {
    dispatch({
      type: 'clearSortOptionId',
    });
  };

  return (
    <Modal title="並び替え" onClose={closeModal} onClear={clearSortOption}>
      <div className={'mx-5'}>
        {sortOptions.map((option) => (
          <Option
            key={option.id}
            name={option.name}
            comment={option.howToEnable?.message}
            onClick={async () => {
              if (option.howToEnable?.message) return;

              // shallow routingなのでrouter.pushしても状態は更新されないので事前に実施
              dispatch({
                type: 'selectSortOptionId',
                payload: {
                  sortOptionId: option.id,
                },
              });

              const { urlQueryParams } = useUrlQueryParams({
                date: selectedDateText,
                areaIds,
                licenseIds,
                facilityFeatureIds,
                jobBenefitIds,
                sortOptionId,
                maximumDailyWage,
                minimumDailyWage,
                workingHourOptionIds,
                maximumWorkingHours,
                jobTaskIds,
                onlyRecruiting,
              });

              await router.push(
                {
                  query: urlQueryParams,
                },
                {
                  // @ts-ignore
                  pathname: router.query.name,
                  query: urlQueryParams,
                },
                { shallow: true },
              );
              closeModal();
            }}
            isCheckVisible={sortOptionId === option.id}
          />
        ))}
      </div>
    </Modal>
  );
};
